// Файл index.js

/**
 * Этот файл является публичной точкой входа компонента Input.
 * По умолчанию наружу экспортируется основной компонент поля ввода.
 * Вместе с ним доступны функции проверки и разбора текстовых тегов.
 * Остальные внутренние детали компонента не требуется импортировать.
 * Такой интерфейс уменьшает связанность кода, использующего Input.
 */

import Input from './Input';

export {
    get_invalid_tags,
    normalize_tag_options,
    tokenize_tag_text,
} from './tag_utils';


export default Input;
